// extracted by mini-css-extract-plugin
export var avatar = "_r2-3";
export var avatarContainer = "_r2-2";
export var avatarSpacer = "_r2-5";
export var avatarSpacerContainer = "_r2-4";
export var avatarStackContainer = "_r2-1";
export var bubble = "_r2-0";
export var remainderBubble = "_r2-6";